import * as SliderPrimitive from "@radix-ui/react-slider";

const THUMB = "block h-4 w-4 rounded-full border border-[hsl(var(--primary))] bg-background shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring";

export function RangeSlider({ max, value, onChange, startLabel, endLabel }) {
  if (max < 2) return null;
  return (
    <div className="pt-2" data-testid="chart-zoom-slider">
      <SliderPrimitive.Root
        className="relative flex w-full touch-none select-none items-center h-5"
        min={0} max={max} step={1} minStepsBetweenThumbs={1}
        value={value} onValueChange={onChange}
        aria-label="Zoom range"
      >
        <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-[hsl(var(--primary))]/20">
          <SliderPrimitive.Range className="absolute h-full bg-[hsl(var(--primary))]" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className={THUMB} aria-label="Zoom start" data-testid="chart-zoom-thumb-start" />
        <SliderPrimitive.Thumb className={THUMB} aria-label="Zoom end" data-testid="chart-zoom-thumb-end" />
      </SliderPrimitive.Root>
      <div className="flex justify-between text-[10px] text-muted-foreground mt-0.5">
        <span>{startLabel}</span><span>{endLabel}</span>
      </div>
    </div>
  );
}
